import { render, staticRenderFns } from "./NewsPopUp.vue?vue&type=template&id=72d6c314&"
import script from "./NewsPopUp.vue?vue&type=script&lang=js&"
export * from "./NewsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./NewsPopUp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports